export const PIC_DELIMITER = "|";

export type SideLoadedMatchedField = "abn" | "pic" | "brands" | "email";

export const MATCHED_FIELD_LABELS: Record<SideLoadedMatchedField, string> = {
  abn: "ABN",
  pic: "PIC",
  brands: "Brands",
  email: "Email",
};

// A row in either the Data Suggestions grid or the Manage grid. Both source
// their rows from selectSideLoadedBusinessesGridList, so datasetLabel is always
// present; matchedFields only applies to a searched suggestion.
export type SideLoadedBusinessRow = SideLoadedBusiness & {
  datasetLabel: string;
  matchedFields?: SideLoadedMatchedField[];
  validationIssues?: string[];
};

export const LABEL_DELIMITER = ",";

/**
 * Split a labels cell into distinct names, mirroring the parsing the API does
 * on import so the compare form shows exactly what will be applied.
 */
export const parseLabelNames = (value: string | undefined | null): string[] => {
  const seen = new Set<string>();
  return (value ?? "").split(LABEL_DELIMITER).reduce<string[]>((acc, raw) => {
    const name = raw.trim();
    if (!name || seen.has(name.toLowerCase())) return acc;
    seen.add(name.toLowerCase());
    acc.push(name);
    return acc;
  }, []);
};
